import { render, staticRenderFns } from "./ReportRatioYear.vue?vue&type=template&id=68347543&scoped=true&"
import script from "./ReportRatioYear.vue?vue&type=script&lang=js&"
export * from "./ReportRatioYear.vue?vue&type=script&lang=js&"
import style0 from "./ReportRatioYear.vue?vue&type=style&index=0&id=68347543&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68347543",
  null
  
)

export default component.exports